import { adminApiClient } from './adminApiClient';
import { createCrudService } from './createCrudService';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface User {
  id: number;
  name: string;
  email: string;
  email_verified_at: string | null;
  roles: string[];
  created_at: string;
  updated_at: string;
}

export interface StoreUserRequest {
  name: string;
  email: string;
  password: string;
}

export interface UpdateUserRequest {
  name?: string;
  email?: string;
  password?: string;
}

export interface ResetPasswordResult {
  id: number;
  email: string;
  sent_to: string;
  sent_at: string;
}

// ---------------------------------------------------------------------------
// Service
// ---------------------------------------------------------------------------

const crud = createCrudService<
  User,
  StoreUserRequest,
  UpdateUserRequest,
  number | string
>('/admin/users');

export const usersService = {
  ...crud,

  /** Replace the user's global RBAC role assignments. */
  async syncRoles(
    userId: string,
    roles: string[],
  ): Promise<{ data: { id: number; roles: string[] } }> {
    const response = await adminApiClient.put<{
      data: { id: number; roles: string[] };
    }>(`/admin/users/${userId}/roles`, { roles });
    return response.data;
  },

  /**
   * Generate a new strong password server-side and email it to the user.
   * `suppressErrorToast`: the global client toasts every 5xx, but the
   * reset modal owns error display — a 502/503 must not surface twice.
   */
  async resetPassword(
    userId: number | string,
  ): Promise<{ data: ResetPasswordResult }> {
    const response = await adminApiClient.post<{ data: ResetPasswordResult }>(
      `/admin/users/${String(userId)}/reset-password`,
      undefined,
      { suppressErrorToast: true },
    );
    return response.data;
  },
};
